/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import moment from 'moment';

import './ListItem.scss';

export default function ListItem({ loading, itemData, confirmTask, denyTask }) {
  const type = itemData.scheduleType;

  // Obtém estágio conforme o operador logado
  const getOperatorStage = () => {
    if (!type) return itemData.stage;

    switch (type) {
      case 'mainInstructor':
      case 'assistantInstructor':
        return itemData?.[type]?.stage;
      case 'driver': {
        const currentUser = JSON.parse(localStorage.getItem('conecta__userData'));
        let operatorStage = null;
        itemData?.driverList?.forEach((driver) => {
          if (driver.userId === currentUser?.id) {
            operatorStage = driver?.stage;
          }
        });
        return operatorStage;
      }
      default:
        return itemData.stage;
    }
  };

  const operatorStage = getOperatorStage() || {};
  const stageName = operatorStage?.name || '';
  const stageId = operatorStage?.id || 0;

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleConfirm = async () => {
    await confirmTask(itemData);
    setIsConfirmModalOpen(false);
  };

  const handleOpenConfirmModal = () => {
    setIsConfirmModalOpen(true);
  };

  const handleOpenDenyModal = () => {
    denyTask(itemData);
  };

  return (
    <div className="custom-list-item">
      <span>
        {itemData.cardTitle} - {itemData.quoteTitle ?? itemData.quoteName} - {itemData.text} -{' '}
        {stageName} - {`${moment(new Date(itemData.startDate)).format('DD/MM/YYYY')}`}
      </span>

      <div className="buttons-wrapper">
        {type && stageId === 1 && (
          <Button
            key="role-confirm"
            style={{
              backgroundColor: '#5cb85c', // Verde
              color: 'white',
              border: 'none',
              opacity: loading ? 0.3 : 1,
            }}
            loading={loading}
            onClick={handleOpenConfirmModal}
          >
            Aceitar
          </Button>
        )}

        {((type && stageId === 1) || (!type && stageId === 12)) && (
          <Button
            key="role-deny"
            style={{
              backgroundColor: '#d9534f', // Vermelho
              color: 'white',
              border: 'none',
              opacity: loading ? 0.3 : 1,
            }}
            loading={loading}
            onClick={handleOpenDenyModal}
          >
            Negar
          </Button>
        )}
      </div>

      <Modal
        title="Confirmar aceite"
        open={isConfirmModalOpen}
        onOk={handleConfirm}
        onCancel={() => setIsConfirmModalOpen(false)}
        okText="Sim"
        cancelText="Cancelar"
        closable={false}
        width="fit-content"
        confirmLoading={loading}
        okButtonProps={{
          style: {
            backgroundColor: '#5cb85c',
            color: 'white',
            border: 'none',
          },
        }}
      >
        <h4>
          Deseja realmente <strong style={{ color: '#5cb85c' }}>aceitar</strong> esta tarefa?
        </h4>
      </Modal>
    </div>
  );
}
